module.exports = __webpack_public_path__ + "img/Vegan Icon - charcoal.eb0e67c5.svg";